import React, { Fragment } from "react";
import cx from "classnames";
import { connect } from "react-redux";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { FaBars } from 'react-icons/fa';
import 'react-toastify/dist/ReactToastify.css';
import HeaderLogo from "../AppLogo";
import V1LOGO from "../../assets/images/V1LOGO.png";
import dhanashakthi from "../../assets/images/dhanashakthi.png";
class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeSearch: false,
      isMobileMenuOpen: false,
    };
  }

  toggleMobileMenu = () => {
    this.setState((prevState) => ({
      isMobileMenuOpen: !prevState.isMobileMenuOpen,
    }));
  };

  render() {
    let { enableMobileMenuSmall } = this.props;
const adminMode = sessionStorage.getItem("adminMode") ? atob(sessionStorage.getItem("adminMode")) : null;

    return (
      <Fragment>
        <TransitionGroup>
          <CSSTransition 
            component="div"
            className={cx("app-header")}
            appear={true} 
            style={{ background: "linear-gradient(135deg,rgb(172, 37, 44),rgb(235, 45, 64),rgb(172, 35, 35))" }} 
            timeout={1500} 
            enter={false} 
            exit={false}
          >
            <div style={{ 
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
              padding: '15px 20px',
              position: 'relative'
            }}>
              
              {/* Centered Logo and Title */}
              <div style={{
                position: 'absolute',
                left: '40%',
                transform: 'translateX(-50%)',
                display: 'flex',
                alignItems: 'center'
              }}>
                  <img 
                  src={dhanashakthi} 
                  alt="Dhana Shankthi" 
                  style={{ 
                    width: '160px', 
                    height: '40px', 
      
                  }} 
                />
                <h3 className="admin-dashboard-title" style={{ 
                  margin: 0,
                  color: '#fff', // Ensure text is visible on any background
                  textShadow: '0 1px 2px rgba(0,0,0,0.3)' // Add shadow for better visibility
                }}>
                  {adminMode === "Admin" 
                    ? "" 
                    : adminMode === "Employee" 
                      ? "" 
                      : `${adminMode} Admin Dashboard`}
                </h3>
              </div>
            </div>
          </CSSTransition>
        </TransitionGroup>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  enableMobileMenuSmall: state.ThemeOptions.enableMobileMenuSmall,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Header);